export default __webpack_public_path__ + "static/media/E61E7E44-A409-4508-AD40-49EB967092FD_1_105_c.701a4470.jpeg";